import React from "react";
import { Box, Skeleton, Tabs, Tab } from "@mui/material";

export default function ShowDetailSkeleton() {
  return (
    <Box sx={{ display: "flex", height: "calc(100vh - 155px + 15px)" }}>
      {/* Main vertical layout */}
      <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
        {/* Top Section */}
        <Box sx={{ flexShrink: 0 }}>
          {/* Breadcrumbs skeleton */}
          <Box sx={{ mb: 2 }}>
            <Skeleton width={200} height={24} />
          </Box>

          {/* Summary cards skeleton */}
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 3 }}>
            {[1, 2, 3, 4].map((i) => (
              <Skeleton
                key={i}
                variant="rectangular"
                width={160}
                height={100}
                sx={{ flex: 1, minWidth: 160 }}
              />
            ))}
          </Box>
        </Box>

        {/* Tabs skeleton */}
        <Tabs value={0}>
          <Tab label={<Skeleton width={60} />} />
          <Tab label={<Skeleton width={60} />} />
          <Tab label={<Skeleton width={60} />} />
        </Tabs>

        {/* Content area skeleton */}
        <Box sx={{ flexGrow: 1, overflow: "hidden" }}>
          <Box
            sx={{
              display: "flex",
              height: "100%",
              borderTop: "1px solid",
              borderColor: "divider",
            }}
          >
            {/* Entry list skeleton */}
            <Box
              sx={{
                minWidth: 300,
                width: 300,
                borderRight: "1px solid",
                borderColor: "divider",
                p: 2,
              }}
            >
              {[1, 2, 3, 4, 5].map((i) => (
                <Box key={i} sx={{ mb: 2 }}>
                  <Skeleton height={24} />
                  <Skeleton height={20} width="80%" />
                  <Skeleton height={20} width="60%" />
                </Box>
              ))}
            </Box>

            {/* Entry detail skeleton */}
            <Box sx={{ flexGrow: 1, p: 3 }}>
              <Skeleton height={32} width={200} />
              <Skeleton height={24} width={150} sx={{ mt: 1 }} />
              <Box sx={{ mt: 4 }}>
                <Skeleton height={40} width="100%" />
                <Box sx={{ mt: 2 }}>
                  {[1, 2, 3, 4].map((i) => (
                    <Box
                      key={i}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mb: 2,
                      }}
                    >
                      <Skeleton height={24} width="40%" />
                      <Skeleton height={24} width="20%" />
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
